import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MonacoEditorDialogData {
  header?: string;
  content?: string;
  readOnly?: boolean;
  language?: string;
}

@Component({
  selector: 'hc-monaco-editor-dialog',
  template: `
    <h2 mat-dialog-title>{{ header }}</h2>
    <mat-dialog-content style="overflow: hidden; max-height: none;">
      <div style="height: 65vh; min-height: 300px; overflow: hidden;">
        <ngx-monaco-editor
          [(ngModel)]="value"
          [options]="editorOptions"
          (onInit)="onEditorInit($event)"
          style="height: 100%; display: block;"
        ></ngx-monaco-editor>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions fxLayoutAlign="end center">
      <button mat-raised-button mat-dialog-close (click)="close()">{{ 'admin.web.close' | trans }}</button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="readOnly">{{ 'admin.web.ok' | trans }}</button>
    </mat-dialog-actions>
  `
})
export class MonacoEditorDialogComponent {
  public header = '';
  public value = '';
  public readOnly = false;

  public editorOptions: any = {
    theme: 'vs',
    language: 'plaintext',
    readOnly: false,
    automaticLayout: true,
    wordWrap: 'on',
    minimap: { enabled: false },
    scrollBeyondLastLine: false
  };

  constructor(
    private dialogRef: MatDialogRef<MonacoEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MonacoEditorDialogData
  ) {
    this.header = data?.header || '';
    this.value = data?.content || '';
    this.readOnly = !!data?.readOnly;

    this.editorOptions = {
      ...this.editorOptions,
      language: data?.language || this.editorOptions.language,
      readOnly: this.readOnly,
      theme: "vs-dark"
    };
  }

  public onEditorInit(editor: any) {
    try {
      if (!editor) {
        return;
      }

      // Open at top (not at the last line)
      editor.setPosition({ lineNumber: 1, column: 1 });
      editor.revealPositionInCenter({ lineNumber: 1, column: 1 });
      editor.focus();
    } catch {
      // ignore
    }
  }

  public save() {
    this.dialogRef.close({
      action: 'save',
      content: this.value
    });
  }

  public close() {
    this.dialogRef.close({
      action: 'close',
      content: this.value
    });
  }
}
